import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@evaneos/b2b-ui';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { AllTranslationKeys } from '../../../shared/intl/types';

import { ModalAllowedStep } from './MoreOptionsMenu';

type StepChangeDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void | null;
    stepType: ModalAllowedStep;
    confirmDisabled?: boolean;
    children?: ReactNode;
    'data-testid'?: string;
};

export const StepChangeDialog = ({
    isOpen,
    onClose,
    onConfirm,
    stepType,
    confirmDisabled = false,
    children,
    'data-testid': dataTestId,
}: StepChangeDialogProps) => {
    const { formatMessage } = useIntl();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="step-change-dialog-title"
            aria-describedby="step-change-dialog-description"
            data-testid={dataTestId}
            maxWidth="md"
            fullWidth
            slotProps={{
                paper: {
                    sx: { padding: 2 },
                },
            }}
        >
            <DialogTitle id="step-change-dialog-title" variant="h2">
                {formatMessage({
                    id: `dossier.${stepType}.request` as AllTranslationKeys,
                })}
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Box id="step-change-dialog-description">
                        <Typography variant="body1">
                            {formatMessage({
                                id: `dossier.${stepType}.message` as AllTranslationKeys,
                            })}
                        </Typography>
                    </Box>
                    {children}
                </Stack>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 0 }}>
                <Button variant="outlined" onClick={onClose}>
                    {formatMessage({ id: 'form.cancel' })}
                </Button>
                <Button
                    variant="contained"
                    disabled={confirmDisabled}
                    onClick={onConfirm}
                    autoFocus
                    sx={{
                        '&.Mui-disabled': {
                            cursor: 'not-allowed',
                        },
                    }}
                >
                    {formatMessage({ id: 'form.submit' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
